<template>
  <div>
    <el-form
      v-for="(item, t_index) in tipsDetail"
      :key="t_index"
      label-width="120px"
      label-position="left"
    >
      <el-form-item :label="'文案'+(t_index+1)+':'">{{item.content}}</el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="场景">{{item.screenType==='full'?'全屏':'小屏'}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开始时间">{{ item.showTime || item.show_time }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束时间">{{ item.endTime || item.end_time }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="位置">{{ $consts.locationTypeText[item.locationType] }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="上下边距">{{ item.marginY }}px</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="左右边距">{{ item.marginX }}px</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="类型">{{ convertType(item.type) }}</el-form-item>
        </el-col>
        <template v-if="item.type === 'txt'">
          <el-col v-if="showTextStyle" :span="8">
            <el-form-item label="展示样式">{{ ['', '文字阴影', '文字加背景色'][item.textStyle] }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="字号">{{ item.fontSize }}px</el-form-item>
          </el-col>
        </template>
        <template v-else>
          <el-col :span="8">
            <el-form-item label="宽度">{{ item.width }}px</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高度">{{ item.height }}px</el-form-item>
          </el-col>
        </template>
      </el-row>
      <template v-if="showTextStyle && item.type === 'qrcode'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="背景字号">{{ item.bgFontSize }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="背景宽度">{{ item.bgW }}px</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="背景高度">{{ item.bgH }}px</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="背景">
              <img :src="item.bgImage" style="width:160px;height:160px;object-fit: contain;">
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    showTextStyle: {
      type: Boolean,
      default: true,
    },
    tipsDetail: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    convertType(type) {
      const typeEnum = {
        txt: '文字',
        image: '图片',
        qrcode: '二维码',
      }
      return typeEnum[type]
    },
  }
}
</script>

<style lang="stylus" scoped>
.el-form
  padding 10px 20px
  border-bottom 1px solid #e9e9e9
  .el-form-item
    margin-bottom 0
</style>
